import { ref } from 'vue'

const grantedToMe = ref([])
const grantedToMeSummary = ref([])
const isSummaryLoading = ref(false)

class AccessService {
  getGrantedToMe() {
    return grantedToMe
  }

  getGrantedToMeSummary() {
    return grantedToMeSummary
  }

  isSummaryLoading() {
    return isSummaryLoading
  }

  async fetchGrantedToMe() {
    try {
      const response = await fetch('/api/Access/GrantedToMe')
      if (!response.ok) {
        grantedToMe.value = []
        return
      }
      grantedToMe.value = await response.json()
    } catch (e) {
      console.error('Failed to fetch granted access:', e)
      grantedToMe.value = []
    }
  }

  async fetchGrantedToMeSummary(force = false) {
    // Skip if already loaded (unless forced)
    if (!force && grantedToMeSummary.value.length > 0) return

    isSummaryLoading.value = true
    try {
      const response = await fetch('/api/Access/GrantedToMeSummary')
      if (!response.ok) {
        grantedToMeSummary.value = []
        return
      }
      grantedToMeSummary.value = await response.json()
    } catch (e) {
      console.error('Failed to fetch granted access summary:', e)
      grantedToMeSummary.value = []
    } finally {
      isSummaryLoading.value = false
    }
  }
}

const accessServiceInstance = new AccessService()
export default accessServiceInstance
